/**
 * Plugin de Breadcrumbs - Gerencia breadcrumbs automaticamente baseado nas rotas
 * 
 * Uso nas rotas:
 * {
 *   path: '/settings/users',
 *   component: () => import('pages/settings/users.vue'),
 *   meta: {
 *     breadcrumbs: {
 *       titleKey: 'pages.settings.users.users',
 *       paths: [
 *         { labelKey: 'pages.settings.settings.preferences', route: '/settings' },
 *         { labelKey: 'pages.settings.users.users', route: '/settings/users' }
 *       ]
 *     }
 *   }
 * }
 */

function getNestedValue(obj, path) {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj)
}

function resolveBreadcrumbs(meta, store, route) {
  if (!meta || !meta.breadcrumbs) return null

  const { breadcrumbs } = meta
  const lang = store.state.localization.language
  const messages = store.state.localization[lang]

  // Se breadcrumbs for uma função, executa passando store e route
  if (typeof breadcrumbs === 'function') {
    return breadcrumbs(store, route)
  }

  // Resolve as chaves de tradução
  const config = {
    title: getNestedValue(messages, breadcrumbs.titleKey) || breadcrumbs.title || '',
    paths: []
  }

  if (breadcrumbs.help) {
    config.help = {
      tooltip: breadcrumbs.help.tooltipKey 
        ? getNestedValue(messages, breadcrumbs.help.tooltipKey) 
        : breadcrumbs.help.tooltip,
      link: breadcrumbs.help.link
    }
  }

  if (breadcrumbs.paths && Array.isArray(breadcrumbs.paths)) {
    config.paths = breadcrumbs.paths.map(path => {
      let resolvedRoute = path.route
      
      // Substitui parâmetros dinâmicos na rota
      if (route.params) {
        Object.keys(route.params).forEach(param => {
          resolvedRoute = resolvedRoute.replace(`:${param}`, route.params[param])
        })
      }

      return {
        label: getNestedValue(messages, path.labelKey) || path.label || '',
        route: resolvedRoute
      }
    })
  }

  return config
}

export function setupBreadcrumbsWatcher(router, store) {
  // Função para atualizar breadcrumbs
  const updateBreadcrumbs = () => {
    const route = router.currentRoute.value
    if (!route || !route.meta) return

    const config = resolveBreadcrumbs(route.meta, store, route)
    if (config) {
      store.commit('main/setBreadcrumbs', config)
    }
  }

  // Observa mudanças de rota
  router.afterEach(() => {
    updateBreadcrumbs()
  })

  // Observa mudanças de idioma
  store.watch(
    (state) => state.localization.language,
    () => {
      updateBreadcrumbs()
    }
  )
}

export default {
  install(app, { router, store }) {
    setupBreadcrumbsWatcher(router, store)
  }
}

